import {IFruitsLayerConfig} from "./IFruitsLayerConfig";
import {IFruitsSymbolStates} from "../game/reelsymbol/FruitsReelSymbol";
import {stat} from "fs";

/**
 * Created by h3 on 2018-09-20.
 */

export class FruitsSymbolScale {

    private static scaledSyms:string[] = [
        "M1",
        "M2",
        "M3",
        "M4",
        "M5",
        "M6",
        "L1",
        "L2",
        "L3",
        "L4",
    ];

    public static getScale(symName:string, stateKey?:string):[number, number]{

        if(FruitsSymbolScale.scaledSyms.indexOf(symName) > -1 && stateKey !== "respin" && stateKey !== "win") {
            return [0.5, 0.5];
        }

        else {
            return [1, 1];
        }


    }
}